import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.5 4.998a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1h-15zm0 8a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1h-15zm0 8a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1h-15zm-7-14c-.827 0-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5h-2zm0-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zm0 12c-.827 0-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5h-2zm0-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zm0 12c-.827 0-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5h-2zm0-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2z"
});

var SvgListBullets1 = function SvgListBullets1() {
  return _ref;
};

export default SvgListBullets1;